import {
  broadcastToParent,
  RegisteredEventName
} from '@finanzcheck/catalyst-pollard'
import { getCookie, COOKIE_KEY_FCID } from 'utils/cookie'
import { getOptimizelyTrackingAttribute } from 'utils/tracking'
import { AmplitudeEvent } from 'utils/tracking/amplitude/amplitude.interface'
import { Data } from 'interfaces/ApolloResponse.interface'

export const trackVoucherActivation = (
  data: Data,
  campaignId: string
): void => {
  broadcastToParent({
    eventName: RegisteredEventName.tracking,
    data: {
      event: AmplitudeEvent.AddToVoucherCampaign,
      voucherCampaignId: campaignId,
      fcId: getCookie(COOKIE_KEY_FCID),
      context: {
        Optimizely: { userId: getCookie(COOKIE_KEY_FCID) },
        ...getOptimizelyTrackingAttribute(data)
      }
    }
  })
}

export const trackVoucherAmountTier = (data: Data, amount: number): void => {
  const event =
    amount < 50000
      ? AmplitudeEvent.RequestedAmountBetween20k50k
      : AmplitudeEvent.RequestedAmountOver50k

  broadcastToParent({
    eventName: RegisteredEventName.tracking,
    data: {
      event,
      context: {
        Optimizely: { userId: getCookie(COOKIE_KEY_FCID) },
        ...getOptimizelyTrackingAttribute(data)
      }
    }
  })
}
